import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link, useNavigate } from "react-router-dom";
import { getData } from "../../FetchNodeServices";
import { InfinitySpin } from "react-loader-spinner";
import { useSelector } from "react-redux";
import AlertMessages from "../Mains/Alerts";

const UserManagement = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullWidthWrapper, setFullWidthWrapper] = useState();
  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [alerts, setAlerts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const customer = useSelector((state) => state.user.users[0]);
  const user = customer.userId;
  const navigate = useNavigate();

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullWidthWrapper(isActivated ? "fullwrapper" : "");
  };

  const fetchUsers = async () => {
    let result = await getData("users/user-management-list?userId=" + user);

    setUserList(result || []);

    setIsLoading(false);
    setAlerts([{ variant: "success", heading: "Data fetched successfully." }]);
  };

  useEffect(() => {
    if (searchTerm.trim() === "") {
      fetchUsers();
    }
  }, [searchTerm, currentPage, itemsPerPage]);

  const handleSearch = async () => {
    let result = await getData("users/user-management-list?search=" + searchTerm);
    if (Array.isArray(result)) {
      setUserList(result);
    } else {
      setUserList([]);
    }
    setIsLoading(false);
  };

  const handleClick = (item) => {
    navigate("/edit-user", { state: { item } });
  };

  const fillUsers = () => {
    if (!Array.isArray(userList)) {
      return null;
    }

    const sortedCustomers = userList.sort((a, b) => b.userId - a.userId);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedCustomers.slice(indexOfFirstItem, indexOfLastItem);

    return currentItems.map((item) => (
      <tr key={item.userId}>
        <td>{item.fullName}</td>
        <td>{item.email}</td>
        <td>{item.team}</td>
        <td>{item.addedOn}</td>
        <td>
          <span className="bg-success-subtle text-teal rounded-pill px-2 py-1 fs-12">{item.status === 1 ? "Active" : "Inactive"}</span>
        </td>
        <td>
          <span className={`${item.userRole === "A" ? "bg-success-subtle" : "bg-warning-subtle"} text-teal rounded-pill px-2 py-1 fs-12`}>
            {item.userRole === "A" ? "Admin" : "Standard"}
          </span>
        </td>
        <td className="fs-16">
          <i className="bi bi-eye mx-1" onClick={() => handleClick(item)}></i>
        </td>
      </tr>
    ));
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullWidthWrapper}>
        <Header onclick={handleToggle} />
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people mx-2"></i>Admin
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i> User Management
              </li>
            </ul>

            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="filter_header fs-12 lh-14">
              <div className="row">
                <div className="col-lg-6">
                  <div className="d-flex gap-1">
                    <div className="search_box">
                      <input type="text" value={searchTerm} className="w-100 form-control" onChange={(event) => setSearchTerm(event.target.value)} />
                    </div>
                    <div className="search_button">
                      <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600" onClick={() => handleSearch()}>
                        <i className="bi bi-search me-1"></i>Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex gap-2 justify-content-end mt-3 mt-lg-0">
                    <Link to="/add-user">
                      <button className="btn btn-success py-0 fs-12 fw-600">
                        <i className="bi bi-plus fs-15"></i> Add new user
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive mt-3">
              <table className="table fs-14 lh-20">
                <thead className="table-light  fs-12 lh-16  border-top">
                  <tr>
                    <th>NAME</th>
                    <th>Email</th>
                    <th>Team Name</th>
                    <th>Added On</th>
                    <th>Users Status</th>
                    <th>User Type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
                      </td>
                    </tr>
                  )}
                  {fillUsers()}
                </tbody>
              </table>
            </div>
            <div className="text-center mt-4">
              <nav aria-label="Page navigation">
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => paginate(currentPage - 1)}>
                      &laquo;
                    </button>
                  </li>
                  {[...Array(Math.ceil(userList.length / itemsPerPage)).keys()].map((_, index) => (
                    <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                      <button className="page-link" onClick={() => paginate(index + 1)}>
                        {index + 1}
                      </button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === Math.ceil(userList.length / itemsPerPage) ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManagement;
